<template>
    <div v-if="filteredProducts" class="row mx-0 catalog-shop-wrapper" :class="{ 'themed-scrollbar' : isDesktop }" @scroll.self.prevent="paginationEvent($event.target)" id="catalogShopWrapper">
        <div v-for="(prod, index) in filteredProducts" :key="'prod-'+index+'-'+prod.groupId" class="col list-item" :data-groupId="prod.groupId"
             :class="{ 'checked' : isSelected(prod.groupId) }"
             @mouseover="onMouseOver(prod)"
             @click="onClick(prod)"
             @mouseleave="closeOptions(true)"
        >
            <div class="click-layer" :data-clkid="prod.clickId" :aria-label="prod.name">&nbsp;</div>
            <div class="shadow-layer"/>
            <LoadImageLazy :classNames="'img-block img-fluid'" :srcImg="prod.img" :srcSet="prod.srcset.toString()" :title="prod.name + '-' + index"/>
            <div class="prod-info">
                <div class="description" v-html="prod.name"/>
                <div class="price-container">
                    <span v-if="prod.priceCrossed" class="price crossed"> {{ prod.priceCrossed }} </span>
                    <span class="price"> {{ prod.price }} </span>
                </div>
            </div>
            <input v-if="isDesktop" type="checkbox" class="pastime-checkbox" :checked="isSelected(prod.groupId)"/>
            <i v-else class="ecom-check" :class="{ 'checked' : isSelected(prod.groupId) }" />
            <MuffinLoader v-if="loadingOptGroupId == prod.groupId"/>
            <transition :name="isDesktop ? transitionName : ''">
                <div v-if="currentPopupOptions && currentPopupOptions.groupId == prod.groupId && currentHoverId == prod.groupId" class="w-100" :class="[ isDesktop ? 'inner-modal-wrapper' : 'outer-modal-wrapper']">
                    <div class="product-box-wrapper">
                        <div v-if="!isDesktop" class="box-header">
                            <p class="box-title"> {{ kStrings.kOPTIONS }} </p>
                            <i class="ecom-close" @click.stop="closeOptions" />
                        </div>
                        <div v-if="!isDesktop" class="box-info">
                            <img :src="currentPopupOptions.img" class="box-img" :alt="currentPopupOptions.name"/>
                            <div class="box-details">
                                <p class="box-name"> {{ currentPopupOptions.name }} </p>
                                <p v-if="currentPopupOptions.label" class="box-label"> {{ currentPopupOptions.label }} </p>
                            </div>
                        </div>
                        <div class="add-product-box" :class="{ 'single-option' : !currentPopupOptions.options.length, 'has-qty' : hasQty }">
                            <!-- qty is now removed for non recipe types -->
                            <div v-if="hasQty" class="simple-quantity-wrapper">
                                <span class="qty-desc"> {{ isDesktop ? kStrings.kQTY + ': ' : kStrings.kQUANTITY + ': ' }} </span>
                                <div class="item-counter">
                                    <i class="ecom-minus" @click.stop="qtyHandler(currentPopupOptions.groupId, false)" />
                                    <span class="item-qty"> {{ currentPopupOptions.quantity.toString().padStart(2, "0") }} </span>
                                    <i class="ecom-plus" @click.stop="qtyHandler(currentPopupOptions.groupId)" />
                                </div>
                            </div>

                            <!-- @input="onOptionClick" -->
                            <SelectVue2 v-if="currentPopupOptions.options.length"
                                        :options="currentPopupOptions.options"
                                        :selected-default="currentPopupOptions.selectedSku"
                                        :maxDisplayOpen="2"
                                        :openUp="true"
                                        :input-label="currentPopupOptions.options[0].label ? currentPopupOptions.options[0].label : kStrings.kOPTIONS"
                                        @input="saveCurrentVariant"
                            />
                            <div class="button-wrapper" :class="{ 'mt-0' : !currentPopupOptions.options.length }">
                                <!-- TODO ADD FROM MEMORY OPTIONS VAR -->
                                <button class="pastime-button" :class="[ isDesktop ? 'light' : 'dark-mode' ]" @click.stop.prevent="saveProduct(prod.groupId)">
                                    {{ !isSelected(currentPopupOptions.groupId) ? kStrings.kSELECT : kStrings.kGLOB_REMOVE }}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </transition>            
<!--            <div v-if="prod.label" class="item-label"> <i v-if="prod.isCoupon" class="icon-promo-code"/> {{ prod.label }} </div>-->
        </div>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';
//import utilities from '@/Utilities/common';
import LoadImageLazy from '@/components/LoadImageLazy';
import request from '@/Utilities/httpRequest';

import MuffinLoader from '@/components/Muffin/Loader';
import SelectVue2 from '@/components/Muffin/SelectVue2';

export default {
    store,
    name: 'CatalogProductShop',
    components: {
        LoadImageLazy,
        MuffinLoader,
        SelectVue2,
    },
    props: {
        //selectedList: {type: Array, default: [], required: true},
        canSelectProducts: {type: Boolean, default: true},
    },
    data() {
        return {
            currentHoverId: null,
            currentPopupOptions: null,
            loadingOptGroupId: null,
            inMemoryOptions: {}, // maybe not the best name -> loadedOptions from hover requests
        }
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        urls() {
            return this.$store.getters.urls;
        },
        pastimeInfo() {
            return this.$store.getters.pastimeInfo;
        },
        isTypeRecipe() {
            return this.pastimeInfo.detailedInfo.isRecipe;
        },
        selectedList(){
            return this.$store.getters['registrationPage/selectedProductsList'];
        },
        filteredProducts() {
            const list = this.$store.getters['registrationPage/productList'];
            return !isEmpty(list) ? list : null
        },
        // selectedProductsList() {
        //     return !isEmpty(this.$store.getters['registrationPage/selectedProductsList']) ? this.$store.getters['registrationPage/selectedProductsList'] : null
        // },
        // currentPopupOptions() {
        //     //console.log('currentPopupOptions', this.currentHoverId, this.inMemoryOptions.find(item => item.groupId == this.currentHoverId))
        //     // if(!this.currentHoverId || isEmpty(this.inMemoryOptions.find(item => item.groupId == this.currentHoverId))) {
        //     //     return null;
        //     // }
            
        //     return this.inMemoryOptions.find(item => item.groupId == this.currentHoverId);
        // },
        hasQty() {
            return this.isTypeRecipe;
        },
        transitionName() {
            return this.currentPopupOptions && this.currentPopupOptions.options.length ? 'slide' : 'less-slide'
        }
    },
    watch: {
        //watched1(value) { }
    },
    created() {
    },
    mounted() {
        //this.$nextTick(() => {});
    },
    methods: {
        isSelected(groupId = null) { // f
            return groupId && !isEmpty(this.selectedList) ? !isEmpty(this.selectedList.find(item => item.groupId == groupId)) : false;
        },
        async paginationEvent(targetElm) {
            if(targetElm && !this.isLoading) {
                //let fullyScrolled = utilities.elementFullScrolled(targetElm);
                let fullyScrolled = targetElm.offsetHeight + targetElm.scrollTop > targetElm.scrollHeight - 400;
                /*let currentScrollPosition = e.srcElement.scrollTop;
                if (currentScrollPosition > this.scrollPosition) {
                    console.log("Scrolling down");
                }
                this.scrollPosition = currentScrollPosition;*/
                if(fullyScrolled) {
                    await this.$emit('catalog-request');
                }
            }
        },
        // canLoadItem(groupId) { // no need to reload again
        //     return isEmpty(this.inMemoryOptions.find(item => item.groupId == groupId));
        // },
        // getProdOptionsFromMemory(groupId) {
        //     let currentProd = this.inMemoryOptions.find(item => item.groupId == groupId); 
        //     if(!this.canSelectProducts){
        //         return currentProd ? this.selectedList.find(item => item.groupId == groupId) : null;
        //     }
        //     return currentProd && !this.loadingOptGroupId && this.currentHoverId == groupId ? currentProd : null;
        // },
        buildOptionsSelect(options = []){
            let built = [];
            if(options.length > 1){
                options.forEach(opt => {
                    built.push({label: opt.option ? opt.option[0].option : '', value: opt.sku, text: opt.option ? opt.option[0].value : ''});
                });
            }
            return built;
        },
        onMouseOver(prod){
            // mouseover is only used for desktop 
            if(this.isDesktop){
                this.loadProductOptions(prod)
            }
        },
        onClick(prod){
            // click is only used for mobile
            if(!this.isDesktop){
                this.loadProductOptions(prod);
            }
        },
        async loadProductOptions(prod) {
            if(this.currentHoverId == prod.groupId){
                //console.log('loadProductOptions Id match ', prod.groupId)
                return;
            }
            this.currentHoverId = prod.groupId;
            let selectedItem = this.selectedList.find(item => item.groupId == prod.groupId);
            if(selectedItem){
                //console.log('loadProductOptions selectedItem ', selectedItem)
                this.currentPopupOptions = selectedItem;
                return;
            }
            this.currentPopupOptions = null;
            //console.log('loadProductOptions selectedItem | can select ', selectedItem, this.canSelectProducts);
            if(!selectedItem && this.canSelectProducts) {
                this.loadingOptGroupId = prod.groupId;
                this.inMemoryOptions[prod.groupId] = {
                    groupId: prod.groupId,
                    img: prod.img,
                    name: prod.name,
                    price: prod.price,
                    priceCrossed: prod.priceCrossed,
                    sku: prod.sku, // default sku
                    srcset: prod.srcset,
                    url: prod.url,
                    // -- -- //
                    //defaultSku: prod.sku,
                    selectedSku: prod.sku,
                    quantity: 1,
                    options: []
                }

                try {
                    const data = await request.get(this.urls.productOptions, {id: prod.groupId});
                    let hasError = data.hasError;
                    if(!hasError) {
                        // update options from ws
                        this.inMemoryOptions[prod.groupId].options = this.buildOptionsSelect(data.data);
                        this.currentPopupOptions = this.inMemoryOptions[prod.groupId];
                    } else {
                        // add bugsnag
                        this.inMemoryOptions[prod.groupId] = null;
                    }
                    //console.log('product options: ', data.data);
                } catch (err) {
                    // setup bugsnag here
                    //console.log('options go boom: ', err);
                    this.inMemoryOptions[prod.groupId] = null;
                }
                this.loadingOptGroupId = null;
            }
        },
        qtyHandler(groupId = null, add = true) {
            if(groupId) {
                let prodQty = this.inMemoryOptions[groupId].quantity;
                if((!add && prodQty > 1) || (add && prodQty < 20)) { // set in backend? this is not a cart item
                    this.inMemoryOptions[groupId].quantity = add ? this.inMemoryOptions[groupId].quantity + 1 : this.inMemoryOptions[groupId].quantity - 1; 
                }
                //console.log('prod updating: ', this.inMemoryOptions[index]);
                //console.log(groupId + ' -> prod qty: ', this.inMemoryOptions[index].quantity);
            }
        },
        placeholder(prod) {
            this.$emit('list-handler', prod);
        },
        async saveProduct(groupId = null) { // removes if already belongs in list (as a toggle)
            let item = groupId && this.inMemoryOptions.hasOwnProperty(groupId) ? this.inMemoryOptions[groupId] : null;
            if(!item) {
                // not found in memory, see if is selected
                item = this.selectedList.find(item => item.groupId == groupId);
            }
            if(item) {
                this.$emit('list-handler', item);
            }
            this.closeOptions();
        },
        saveCurrentVariant(sku) {
            //console.log('updated sku: ', sku);
            let item = this.inMemoryOptions.hasOwnProperty(this.currentHoverId) ? this.inMemoryOptions[this.currentHoverId] : null;
            if(item) {
                item.selectedSku = sku;
                const option = item.options.find(opt => opt.value == sku);
                item.label = option ? option.label + ': ' + option.text : '';
                this.inMemoryOptions[item.groupId] = item;
                //console.log('chosen variant: ', this.inMemoryOptions[index].label);
            }
        },
        closeOptions(mouseleave = false){
            if(mouseleave === true && !this.isDesktop){
                // ignore it, mobile uses click
                return ;
            }
            this.currentHoverId = null; 
            this.currentPopupOptions = null;
        },
    }
};
</script>

<style scoped>

</style>